import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  IconButton,
  Typography,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Stack,
  useThemeProps,
  FormHelperText,
} from "@mui/material";
import Logo from "../../../assets/images/common/chat-logo.png";
import { useTheme } from "@mui/material/styles";
import {
  Newchat,
  Dropdown,
  Gemini,
  Chatlike,
  Chatdislike,
  Chatrefresh,
  Chatcopy,
  Sendmessege,
  Modalclose,
  Diamondicon,
  Listcircle,
  Hamburguricon,
  Dollaricon,
  Stripe,
} from "../../../icons/icons";
import Link from "@mui/material/Link";
import Autocomplete from "@mui/material/Autocomplete";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid2";
import { useDispatch, useSelector } from "react-redux";
import { ModelSelection } from "../../../redux/chatslice";
import Mywalletbackground from "../../../assets/images/common/my-wallet-background.png";
import Chatgpt from "../../../assets/images/common/chatgpt-logo.png";
import Geminilogo from "../../../assets/images/common/gemini-logo.png";
import Gemma from "../../../assets/images/common/gemma-logo.png";
import Mistral from "../../../assets/images/common/mistral-logo.png";
import Websearch from "../../../assets/images/common/web-search-logo.png";
import Walleticon from "../../../assets/images/common/wallet-img.png";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import moment from "moment-timezone";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import {
  Transactionhistory,
  Modelby,
  Billinginfo,
  Paymentsession,
} from "./../../../redux/transactionslice";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { decryptUserId } from "../../../utilis/encrypto";
import { Getprofile } from "../../../redux/authSlice";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const columns = [
  { id: "name", label: "Name", minWidth: 170 },
  { id: "code", label: "ISO\u00a0Code", minWidth: 100 },
  {
    id: "population",
    label: "Population",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "size",
    label: "Size\u00a0(km\u00b2)",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "density",
    label: "Density",
    minWidth: 170,
    align: "right",
    format: (value) => value.toFixed(2),
  },
];





function Mywallet() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const dispatch = useDispatch();
  const { getprofile } = useSelector((state) => state.admin);
  // console.log(getprofile,"eee")
  const { transhistory, modelby, billing, payurl } = useSelector(
    (state) => state.transactions
  );

  // console.log('Transaction State:', { transhistory, modelby, billing, payurl });
  const [price, setPrice] = useState("");
  const [error, setError] = useState({ price: "" });

  // Validation function: ensure the value is not empty and is a positive number
  const validateForm = () => {
    let amountError = "";

    // Amount validation
    if (!price) {
      amountError = "Amount is required";
    } else if (isNaN(price) || parseFloat(price) <= 0) {
      amountError = "Amount must be a number greater than zero";
    }

    setError({ price: amountError });

    // Return true if there are no validation errors
    return !amountError;
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const subscribe = payurl?.session?.url;
  // console.log(subscribe, "subbbbbbb")

  useEffect(() => {
    dispatch(Getprofile());
  }, [dispatch]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    dispatch(Transactionhistory());
    dispatch(Modelby());
    dispatch(Billinginfo());
  }, [dispatch]);

  const [openB, setOpenB] = React.useState(false);

  const handleClickOpenB = () => {
    if (!validateForm()) {
      return;
    }
    setOpenB(true);
  };
  const handlePriceChange = (event) => {
    const value = event.target.value;
    setPrice(value);

    // Validate the input and set error state
    if (!validateForm(value)) {
      setError(true);
    } else {
      setError(false);
    }
  };
  const handleCloseB = () => {
    setOpenB(false);
  };

  const handlepay = () => {
    // Validate price before proceeding

    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    const payload = { user_id: userId, price: price };
    dispatch(Paymentsession(payload))
      .unwrap()
      .then((response) => {
        const paymentUrl = response?.session?.url;
        if (paymentUrl) {
          window.location.href = paymentUrl;
        } else {
          console.error("Payment URL not found!");
        }
      })
      .catch((err) => {
        console.error("Payment session error:", err);
      });
  };

  const [openc, setOpenc] = React.useState(false);

  const handleClickOpenc = () => {
    setOpenc(true);
  };

  const handleClosec = () => {
    setOpenc(false);
  };

  const formatBillingValue = (val) => {
    return val.replace(/(\d)(\/)/g, "1/");
  };
  return (
    <>
      <Box>
        <Stack
          direction={"row"}
          alignItems={"center"}
          sx={{
            p: { xs: "14px 12px", sm: "16px 32px" },
            borderBottom: "1px solid",
            borderBottomColor: '#0A43AE',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: theme.palette.secondary.main,
              fontSize: "20px",
              fontWeight: "700",
            }}
            fullWidth
          >
            My Wallet
          </Typography>
        </Stack>
        <Box sx={{ p: { xs: "20px 12px", sm: "24px 32px" } }}>
          <Grid container sx={{ height: "100%" }}>
            <Grid size={{ xs: 12, sm: 6, xl: 7 }}>
              <Box
                sx={{
                  borderRight: { xs: "0px solid", sm: "1px solid" },
                  borderRightColor: {
                    xs: '#0A43AE',
                    sm: '#0A43AE',
                  },
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    backgroundImage: `url(${Mywalletbackground})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "100% 80%",
                    p: { xs: "10px", lg: "20px", xl: "40px" },
                    mr: { sm: "20px", lg: "40px", xl: "80px" },
                    borderRadius: "16px",
                    width: "100%",
                  }}
                >
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    spacing={"20px"}
                    sx={{ mb: { xs: "16px", lg: "24px" } }}
                  >
                    <Box>
                      <img src={Walleticon} alt="wallet" />
                    </Box>
                    <Box>
                      <Typography
                        variant="h2"
                        sx={{
                          color: theme.palette.white.white,
                          fontSize: { xs: "18px", sm: "24px" },
                          fontWeight: "500",
                          pb: "6px",
                        }}
                        fullWidth
                      >
                        Wallet Balance
                      </Typography>
                      <Typography
                        variant="h2"
                        sx={{
                          color: theme.palette.white.white,
                          fontSize: { xs: "24px", sm: "38px" },
                          fontWeight: "700",
                        }}
                        fullWidth
                      >
                        $ {getprofile.balance}
                      </Typography>
                    </Box>
                  </Stack>

                  <Link
                    href="#"
                    sx={{
                      color: theme.palette.secondary.main,
                      fontWeight: "500",
                      fontSize: "16px",
                      textDecoration: "underline",
                    }}
                    onClick={handleClickOpenc}
                  >
                    Billing information
                  </Link>

                  {/* billing-popup */}
                  <Dialog
                    open={openc}
                    onClose={handleClosec}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                      "& .css-umy2on-MuiPaper-root-MuiDialog-paper": {
                        width: "375px",
                      },
                    }}
                  >
                    <DialogTitle id="alert-dialog-title" sx={{ p: 0 }}>
                      <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        sx={{
                          borderBottom: "1px solid",
                          borderBottomColor: '#0A43AE',
                          pb: "12px",
                        }}
                      >
                        <Typography
                          variant="p"
                          sx={{
                            color: theme.palette.secondary.main,
                            fontWeight: "700",
                            fontSize: "20px",
                          }}
                        >
                          Billing Information
                        </Typography>
                        <DialogActions>
                          <Button
                            onClick={handleClosec}
                            sx={{ p: 0, minWidth: "auto", height: "auto" }}
                          >
                            <Modalclose />
                          </Button>
                        </DialogActions>
                      </Stack>
                    </DialogTitle>

                    <DialogContent sx={{ p: 0 }}>
                      {billing?.data?.map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            borderTop: "1px solid",
                            borderTopColor: '#0A43AE',
                            py: "20px",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid size={{ xs: 6, xl: 6 }}>
                              <Typography
                                variant="p"
                                sx={{
                                  color: theme.palette.white.white,
                                  fontWeight: "500",
                                  fontSize: "18px",
                                }}
                              >
                                {item.title}
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, xl: 6 }}>
                              <Stack
                                spacing={1}
                                justifyContent={"end"}
                                alignItems={"end"}
                              >
                                {item.value.map((val, idx) => (
                                  <Typography
                                    key={idx}
                                    sx={{
                                      color: theme.palette.secondary.main,
                                      fontWeight: "400",
                                      fontSize: "16px",
                                      width: "auto",
                                    }}
                                  >
                                    {formatBillingValue(val)}
                                  </Typography>
                                ))}
                              </Stack>
                            </Grid>
                          </Grid>
                        </Box>
                      ))}
                    </DialogContent>
                  </Dialog>

                  {/* <Dialog
                    open={openc}
                    onClose={handleClosec}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                      "& .css-umy2on-MuiPaper-root-MuiDialog-paper": {
                        width: "375px",
                      },
                    }}
                  >
                    <DialogTitle id="alert-dialog-title" sx={{ p: 0 }}>
                      <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        sx={{
                          borderBottom: "1px solid",
                          borderBottomColor: theme.palette.greyshades.grey100,
                          pb: "12px",
                        }}
                      >
                        <Typography
                          variant="p"
                          sx={{
                            color: theme.palette.secondary.main,
                            fontWeight: "700",
                            fontSize: "20px",
                          }}
                        >
                          Transaction Details
                        </Typography>
                        <DialogActions>
                          <Button
                            onClick={handleClosec}
                            sx={{ p: 0, minWidth: "auto", height: "auto" }}
                          >
                            <Modalclose />
                          </Button>
                        </DialogActions>
                      </Stack>
                    </DialogTitle>

                    <DialogContent sx={{ p: 0 }}>
                      <Box
                        sx={{
                          borderTop: "1px solid",
                          borderTopColor: theme.palette.greyshades.grey100,
                          py: "20px",
                        }}
                      >
                        <Grid container>
                          <Grid size={{ xs: 8, xl: 8 }}>
                            <Stack direction={"row"} alignItems={"center"}>
                              <Box
                                sx={{
                                  background: theme.palette.greyshades.grey100,
                                  width: "76px",
                                  minWidth: "76px",
                                  maxWidth: "76px",
                                  height: "76px",
                                  borderRadius: "12px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  mr: "18px",
                                }}
                              >
                                <Diamondicon />
                              </Box>
                              <Box>
                                <Typography
                                  variant="p"
                                  sx={{
                                    color: theme.palette.white.white,
                                    fontWeight: "500",
                                    fontSize: "18px",
                                  }}
                                >
                                  Token Deduction
                                </Typography>
                                <Typography
                                  variant="p"
                                  sx={{
                                    color: theme.palette.white.white,
                                    fontWeight: "500",
                                    fontSize: "18px",
                                  }}
                                >
                                  Transaction ID: TXN678546
                                </Typography>
                                <Stack direction={"row"} alignItems={"center"}>
                                  <Typography
                                    variant="p"
                                    sx={{
                                      color: theme.palette.secondary.main,
                                      fontWeight: "300",
                                      fontSize: "16px",
                                    }}
                                  >
                                    10:00 AM
                                  </Typography>
                                  <Box sx={{ px: "8px" }}>
                                    <Listcircle />
                                  </Box>

                                  <Typography
                                    variant="p"
                                    sx={{
                                      color: theme.palette.secondary.main,
                                      fontWeight: "300",
                                      fontSize: "16px",
                                    }}
                                  >
                                    11 May’ 24
                                  </Typography>
                                </Stack>
                              </Box>
                            </Stack>
                          </Grid>
                          <Grid size={{ xs: 4, xl: 4 }}>
                            <Typography
                              fullWidth
                              sx={{
                                color: "#00FFA3",
                                fontWeight: "700",
                                fontSize: "20px",
                                textAlign: "end",
                              }}
                            >
                              $15
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                      <Box
                        sx={{
                          borderTop: "1px solid",
                          borderTopColor: theme.palette.greyshades.grey100,
                          py: "20px",
                        }}
                      >
                        <Typography
                          variant="p"
                          sx={{
                            color: theme.palette.secondary.main,
                            fontWeight: "400",
                            fontSize: "18px",
                          }}
                        >
                          Payment Breakdown
                        </Typography>
                        <Grid container>
                          <Grid size={{ xs: 6, xl: 6 }}>
                            <Typography
                              variant="p"
                              sx={{
                                color: theme.palette.white.white,
                                fontWeight: "500",
                                fontSize: "18px",
                              }}
                            >
                              ChatGPT
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 6, xl: 6 }}>
                            <Typography
                              fullWidth
                              sx={{
                                color: theme.palette.white.white,
                                fontWeight: "700",
                                fontSize: "18px",
                                textAlign: "end",
                              }}
                            >
                              $12
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>

                      <Box
                        sx={{
                          borderTop: "1px solid",
                          borderTopColor: theme.palette.greyshades.grey100,
                          paddingTop: "20px",
                        }}
                      >
                        <Grid container>
                          <Grid size={{ xs: 6, xl: 6 }}>
                            <Typography
                              variant="p"
                              sx={{
                                color: theme.palette.white.white,
                                fontWeight: "500",
                                fontSize: "18px",
                              }}
                            >
                              Service Charges
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 6, xl: 6 }}>
                            <Typography
                              fullWidth
                              sx={{
                                color: theme.palette.white.white,
                                fontWeight: "700",
                                fontSize: "18px",
                                textAlign: "end",
                              }}
                            >
                              $3
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </DialogContent>
                  </Dialog> */}
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, xl: 5 }}>
              <Box
                sx={{
                  p: { sm: "0 0 0 20px", lg: "0 0 0 40px", xl: "0 0 0 80px" },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    color: theme.palette.secondary.main,
                    fontSize: "16px",
                    fontWeight: "400",
                    p: { xs: " 40px 0 8px 0", sm: "20px 0 20px 0" },
                  }}
                  fullWidth
                >
                  Payment Type
                </Typography>

                <Stack direction={"row"} alignItems={"center"}>
                  <Box>
                    <Dollaricon />
                  </Box>

                  <Typography
                    variant="h2"
                    sx={{
                      color: theme.palette.secondary.main,
                      fontSize: "20px",
                      fontWeight: "700",
                      ml: "12px",
                    }}
                  >
                    Recharge Once
                  </Typography>
                </Stack>
                <FormControl
                  fullWidth
                  sx={{ m: { xs: "14px 0 ", lg: "16px 0 20px 0" } }}
                >
                  <OutlinedInput
                    name="price"
                    placeholder="Enter Amount"
                    value={price}
                    onChange={handlePriceChange}
                    className="custom-input"
                    sx={{
                      color: "#fff",
                      // background: theme.palette.greyshades.grey100,
                    }}
                  />
                  {error.price && (
                    <FormHelperText error>{error.price}</FormHelperText>
                  )}
                </FormControl>

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{
                    mb: 2,
                    p: { xs: "6px", lg: "10px" },
                    backgroundColor: "primary.Main",
                    fontSize: { xs: "16px", lg: "18px" },
                    fontWeight: "500",
                    borderRadius: "50px",
                    height: "auto",
                  }}
                  onClick={handleClickOpenB}
                >
                  Top Up Wallet
                </Button>

                <Dialog
                  open={openB}
                  onClose={handleCloseB}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  sx={{
                    "& .css-umy2on-MuiPaper-root-MuiDialog-paper": {
                      width: "375px",
                    },
                  }}
                >
                  <DialogTitle id="alert-dialog-title" sx={{ p: 0 }}>
                    <Stack
                      direction={"row"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      sx={{
                        borderBottom: "1px solid",
                        borderBottomColor: '#0A43AE',
                        pb: "12px",
                      }}
                    >
                      <Typography
                        variant="p"
                        sx={{
                          color: theme.palette.secondary.main,
                          fontWeight: "700",
                          fontSize: "20px",
                        }}
                      >
                        Payment Gateway
                      </Typography>
                      <DialogActions>
                        <Button
                          onClick={handleCloseB}
                          sx={{ p: 0, minWidth: "auto", height: "auto" }}
                        >
                          <Modalclose />
                        </Button>
                      </DialogActions>
                    </Stack>
                  </DialogTitle>

                  <DialogContent sx={{ p: 0 }}>
                    <Stack
                      direction={"row"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      sx={{
                        border: "1px solid",
                        borderColor: '#0A43AE',
                        borderRadius: "12px",
                        p: "22px 20px",
                        my: "16px",
                      }}
                    >
                      <Typography
                        variant="p"
                        sx={{
                          color: theme.palette.white.white,
                          fontWeight: "400",
                          fontSize: "16px",
                        }}
                      >
                        Amount to Pay
                      </Typography>
                      <Typography
                        variant="p"
                        sx={{
                          color: theme.palette.white.white,
                          fontWeight: "400",
                          fontSize: "20px",
                        }}
                      >
                        ${price}
                      </Typography>
                    </Stack>

                    <Typography
                      variant="p"
                      sx={{
                        color: theme.palette.secondary.main,
                        fontWeight: "400",
                        fontSize: "16px",
                      }}
                    >
                      Payment Methods
                    </Typography>

                    <Stack
                      direction={"row"}
                      justifyContent={"start"}
                      alignItems={"center"}
                      sx={{
                        border: "1px solid",
                        borderColor: '#0A43AE',
                        borderRadius: "12px",
                        p: "22px 20px",
                        my: "12px",
                      }}
                    >
                      <Box>
                        <Stripe />
                      </Box>
                      <Typography
                        variant="p"
                        sx={{
                          color: theme.palette.secondary.main,
                          fontWeight: "500",
                          fontSize: "18px",
                          paddingLeft: "10px",
                        }}
                      >
                        Stripe
                      </Typography>
                    </Stack>
                    <Stack
                      justifyContent={"center"}
                      alignItems={"start"}
                      sx={{
                        borderRadius: "12px",
                        p: "22px 20px",
                        my: "16px",
                        backgroundImage: `url(${Mywalletbackground})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "100% 80%",
                      }}
                    >
                      <Typography
                        variant="p"
                        sx={{
                          color: theme.palette.white.white,
                          fontWeight: "700",
                          fontSize: "16px",
                          marginBottom: "14px",
                        }}
                      >
                        Looking for a detailed price breakdown?
                      </Typography>

                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{
                          p: "10px 12px",
                          backgroundColor: "white.white",
                          fontSize: "14px",
                          fontWeight: "700",
                          borderRadius: "50px",
                          height: "auto",
                          color: "primary.main",
                          lineHeight: "normal",
                          '&:hover': {
                            backgroundColor: "white.white",
                          }
                        }}
                      >
                        View Billing Information
                      </Button>
                    </Stack>

                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{
                        p: "10px 22px",
                        backgroundColor: "primary.Main",
                        fontSize: "18px",
                        fontWeight: "500",
                        borderRadius: "50px",
                        height: "auto",
                      }}
                      onClick={handlepay}
                    >
                      Pay Now
                    </Button>
                  </DialogContent>
                </Dialog>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ p: { xs: "14px 12px", sm: "10px 32px" } }}>
          <Typography
            variant="h2"
            sx={{
              color: theme.palette.secondary.main,
              fontSize: "20px",
              fontWeight: "700",
            }}
            fullWidth
          >
            Transaction History
          </Typography>
        </Box>

        <Box sx={{ width: "100%", "& .css-19kzrtu": { p: 0 } }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Recent" {...a11yProps(0)} />
              <Tab label="By Model" {...a11yProps(1)} />
            </Tabs>
          </Box>

          <CustomTabPanel value={value} index={0}>
            <Paper sx={{ width: "100%", overflow: "hidden" }} elevation={0}>
              <TableContainer sx={{ maxHeight: 300 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Transaction Name</TableCell>
                      <TableCell>Transaction ID</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Time</TableCell>
                      <TableCell width={"150px"}>Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {transhistory && transhistory.data?.length > 0 ? (
                      transhistory.data.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.title}</TableCell>
                          <TableCell sx={{ fontWeight: "500" }}>
                            {item.transaction_id}
                          </TableCell>
                          <TableCell>
                            {moment(item.transaction_time)
                              .local()
                              .format("DD-MM-YYYY")}
                          </TableCell>
                          <TableCell>
                            {moment
                              .utc(item.transaction_time) // Treat as UTC
                              .local() // Convert to the system's local time
                              .format("HH:mm ")}
                          </TableCell>
                          <TableCell
                            sx={{ color: "#00FFA3", fontWeight: "700" }}
                          >
                            <Box>
                              <Box sx={{ color: "#00FFA3" }}>
                                $ {item.balance === null ? 0 : item.balance}
                              </Box>
                              <Box
                                sx={{
                                  color:
                                    item.payment_status === "unpaid"
                                      ? "red"
                                      : "00FFA3",
                                }}
                              >
                                {item.payment_status}
                              </Box>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          No Transaction Yet
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Paper sx={{ width: "100%", overflow: "hidden" }} elevation={0}>
              <TableContainer sx={{ maxHeight: 300 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Platform</TableCell>
                      <TableCell>Model Name</TableCell>
                      <TableCell width={"150px"}>Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {modelby?.data?.map((item, index) => (
                      <TableRow key={item.id || index}>
                        <TableCell sx={{ fontWeight: "500" }}>
                          {item.name}
                        </TableCell>

                        <TableCell sx={{ fontStyle: "italic" }}>
                          {item.details.map((detail, i) => (
                            <Typography>{detail}</Typography>
                          ))}
                        </TableCell>

                        <TableCell sx={{ fontWeight: "500" }}>
                          {item.amount}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </CustomTabPanel>
        </Box>
      </Box>
    </>
  );
}
export default Mywallet;
